import { GET_BACKGROUND_IMAGE } from '../actions/backgroundImageActions';

const initialState = {
	backgroundImageIsRefreshing: false
};

export function backgroundImage(state = initialState, action) {
	switch (action.type) {
		case GET_BACKGROUND_IMAGE.pending:
			{
				return {
					...state,
					backgroundImageIsRefreshing: true
				};
			}

		case GET_BACKGROUND_IMAGE.fulfilled:
			{
				return {
					...state,
					images: action.payload,
					lastError: {},
					backgroundImageIsRefreshing: false
				};
			}

		case GET_BACKGROUND_IMAGE.rejected:
			{
				return {
					...state,
					images: undefined,
					lastError: action.payload,
					backgroundImageIsRefreshing: false
				};
			}
	}

	return state;
}